export const MainWrapper = 'flex flex-col w-full'

export const Headline = 'mb-4 text-black font-Roboto'
